import React from "react";
import { useApp } from "@/context/AppContext";

export function Logo({ size = "md", tagline = false }) {
  const { t } = useApp();
  const sizes = { sm: "text-xl", md: "text-2xl sm:text-3xl", lg: "text-4xl sm:text-5xl" };
  return (
    <div className="text-center select-none" data-testid="brand-logo">
      <div className={`font-serif-cu tracking-[0.18em] ${sizes[size]} gold-text leading-none`}>CAUGHT UP</div>
      <div className="eyebrow mt-1.5" style={{ letterSpacing: "0.5em" }}>INTERNATIONAL</div>
      {tagline && <div className="eyebrow mt-3 text-[color:var(--cu-muted)]">{t("tagline")}</div>}
    </div>
  );
}
